import styled from 'styled-components'

import { SvgFilter } from './SvgFilter'
import { SvgSort } from './SvgSort'

export const FilterIcon = styled(SvgFilter)`
  margin-inline-end: 5px;
`

export const SortIcon = styled(SvgSort)`
  margin-inline-end: 5px;
`
